export default __webpack_public_path__ + "static/media/logo.80a85513.png";